/* tslint:disable */
/* eslint-disable */
/**
 * Vocabulary Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Notation,
  VocabularyAsList,
  VocabularyAsSet,
} from '../models/index';
import {
    NotationFromJSON,
    NotationToJSON,
    VocabularyAsListFromJSON,
    VocabularyAsListToJSON,
    VocabularyAsSetFromJSON,
    VocabularyAsSetToJSON,
} from '../models/index';

export interface ContentionRequest {
    duration?: number;
    frequency?: number;
}

export interface GetExternalGrammarRequest {
    path: string;
}

export interface GetNotationLabelRequest {
    name: string;
    notation: string;
}

export interface GetVocabulariesRequest {
    body?: string;
}

export interface GetVocabularyAsListRequest {
    name: string;
}

export interface GetVocabularyAsSetRequest {
    name: string;
}

export interface ProfileRequest {
    duration?: number;
    frequency?: number;
}

export interface UpdateRegistryRequest {
    body?: string;
}

/**
 * 
 */
export class VocabularyServiceApi extends runtime.BaseAPI {

    /**
     * Creates request options for contention without sending the request
     */
    async contentionRequestOpts(requestParameters: ContentionRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['duration'] != null) {
            queryParameters['duration'] = requestParameters['duration'];
        }

        if (requestParameters['frequency'] != null) {
            queryParameters['frequency'] = requestParameters['frequency'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pprof/contention`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async contentionRaw(requestParameters: ContentionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const requestOptions = await this.contentionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async contention(requestParameters: ContentionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.contentionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getExternalGrammar without sending the request
     */
    async getExternalGrammarRequestOpts(requestParameters: GetExternalGrammarRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling getExternalGrammar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/application.wadl/{path}`;
        urlPath = urlPath.replace(`{${"path"}}`, encodeURIComponent(String(requestParameters['path'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getExternalGrammarRaw(requestParameters: GetExternalGrammarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.getExternalGrammarRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getExternalGrammar(requestParameters: GetExternalGrammarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getExternalGrammarRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getNotationLabel without sending the request
     */
    async getNotationLabelRequestOpts(requestParameters: GetNotationLabelRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling getNotationLabel().'
            );
        }

        if (requestParameters['notation'] == null) {
            throw new runtime.RequiredError(
                'notation',
                'Required parameter "notation" was null or undefined when calling getNotationLabel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/vocabulary/{name}/notation/{notation}`;
        urlPath = urlPath.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters['name'])));
        urlPath = urlPath.replace(`{${"notation"}}`, encodeURIComponent(String(requestParameters['notation'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a notation of a controlled vocabulary as representation in JSON.
     */
    async getNotationLabelRaw(requestParameters: GetNotationLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Notation>> {
        const requestOptions = await this.getNotationLabelRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotationFromJSON(jsonValue));
    }

    /**
     * Get a notation of a controlled vocabulary as representation in JSON.
     */
    async getNotationLabel(requestParameters: GetNotationLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Notation> {
        const response = await this.getNotationLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getVocabularies without sending the request
     */
    async getVocabulariesRequestOpts(requestParameters: GetVocabulariesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/vocabulary/registry`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * Get the supported controlled vocabularies in JSON.
     */
    async getVocabulariesRaw(requestParameters: GetVocabulariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.getVocabulariesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get the supported controlled vocabularies in JSON.
     */
    async getVocabularies(requestParameters: GetVocabulariesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getVocabulariesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getVocabularyAsList without sending the request
     */
    async getVocabularyAsListRequestOpts(requestParameters: GetVocabularyAsListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling getVocabularyAsList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/vocabulary/{name}/as_list`;
        urlPath = urlPath.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters['name'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a controlled vocabulary as a list representation in JSON.
     */
    async getVocabularyAsListRaw(requestParameters: GetVocabularyAsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VocabularyAsList>> {
        const requestOptions = await this.getVocabularyAsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VocabularyAsListFromJSON(jsonValue));
    }

    /**
     * Get a controlled vocabulary as a list representation in JSON.
     */
    async getVocabularyAsList(requestParameters: GetVocabularyAsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VocabularyAsList> {
        const response = await this.getVocabularyAsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getVocabularyAsSet without sending the request
     */
    async getVocabularyAsSetRequestOpts(requestParameters: GetVocabularyAsSetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling getVocabularyAsSet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/vocabulary/{name}/as_set`;
        urlPath = urlPath.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters['name'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a controlled vocabulary as a set representation in JSON.
     */
    async getVocabularyAsSetRaw(requestParameters: GetVocabularyAsSetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VocabularyAsSet>> {
        const requestOptions = await this.getVocabularyAsSetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VocabularyAsSetFromJSON(jsonValue));
    }

    /**
     * Get a controlled vocabulary as a set representation in JSON.
     */
    async getVocabularyAsSet(requestParameters: GetVocabularyAsSetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VocabularyAsSet> {
        const response = await this.getVocabularyAsSetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getWadl without sending the request
     */
    async getWadlRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/application.wadl`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getWadlRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.getWadlRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getWadl(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getWadlRaw(initOverrides);
    }

    /**
     * Creates request options for profile without sending the request
     */
    async profileRequestOpts(requestParameters: ProfileRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['duration'] != null) {
            queryParameters['duration'] = requestParameters['duration'];
        }

        if (requestParameters['frequency'] != null) {
            queryParameters['frequency'] = requestParameters['frequency'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/pprof/profile`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async profileRaw(requestParameters: ProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const requestOptions = await this.profileRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async profile(requestParameters: ProfileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.profileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateCache without sending the request
     */
    async updateCacheRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/update/cache`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Updates the cache for the controlled vocabularies.
     */
    async updateCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateCacheRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the cache for the controlled vocabularies.
     */
    async updateCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCacheRaw(initOverrides);
    }

    /**
     * Creates request options for updateRegistry without sending the request
     */
    async updateRegistryRequestOpts(requestParameters: UpdateRegistryRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/update/registry`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * Updates the vocabularies registry and the cache for the controlled vocabularies.
     */
    async updateRegistryRaw(requestParameters: UpdateRegistryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateRegistryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the vocabularies registry and the cache for the controlled vocabularies.
     */
    async updateRegistry(requestParameters: UpdateRegistryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateRegistryRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateRepository without sending the request
     */
    async updateRepositoryRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/update/repository`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Updates the repository for the controlled vocabularies from sources.
     */
    async updateRepositoryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateRepositoryRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the repository for the controlled vocabularies from sources.
     */
    async updateRepository(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateRepositoryRaw(initOverrides);
    }

}
